module.exports = __webpack_public_path__ + "static/media/Sara.53dd372b.png";